import React from 'react';
import Navbar from '../components/landing/Navbar';
import HeroSection from '../components/landing/HeroSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import StepsSection from '../components/landing/StepsSection';
import ReviewsSection from '../components/landing/ReviewsSection';
import FooterSection from '../components/landing/FooterSection';
import { useAppContext } from '../context/AppContext';

export default function Landing({ onSignIn, onGetStarted }) {
  const { theme, toggleTheme } = useAppContext();

  return (
    <main
      data-landing-theme={theme}
      className="min-h-screen font-ui overflow-x-hidden transition-colors duration-300"
      style={{ background: 'var(--lp-bg)', color: 'var(--lp-text)' }}
    >
      <Navbar
        onSignIn={onSignIn}
        onGetStarted={onGetStarted}
        landingTheme={theme}
        onToggleTheme={toggleTheme}
      />
      <HeroSection onGetStarted={onGetStarted} />
      <div id="features">
        <FeaturesSection />
      </div>
      <div id="how-it-works">
        <StepsSection />
      </div>
      <div id="reviews">
        <ReviewsSection />
      </div>
      <FooterSection />
    </main>
  );
}

